import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../plugins/https";
import { setTeam, getTeam, updateTeam, deleteTeam } from "./action";
import { SET_TEAM, GET_TEAM, DELETE_TEAM, UPDATE_TEAM } from "./actionType";

export const addTeam = (team) => async (dispatch) => {
  try {
    const res = await PostRequest("/team", team);
    console.log("The team data", res);
    dispatch(getTeamData());
  } catch (error) {
    console.error(error);
  }
};

export const getTeamData = () => async (dispatch) => {
  try {
    const res = await GetRequest("/team");
    dispatch(setTeam(res.data.data));

    dispatch(getTeam(res.data.data));
  } catch (error) {
    console.error("Error getting team data : ", error);
  }
};

export const updateTeaMData = (updateTeamData, id) => async (dispatch) => {
  try {
    const res = await PutRequest(`/team/${id}`, updateTeamData);
    dispatch(updateTeam(res.data));
    dispatch(getTeamData());
  } catch (error) {
    console.error("Error in updating team: ", error);
  }
};

export const deleteTeamData = (id) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/team/${id}`);
    dispatch(deleteTeam(id));
    dispatch(getTeamData());
  } catch (error) {
    console.error("Error in deleting team: ", error);
  }
};

const initialState = {
  teamData: [],
};

export const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEAM:
      return {
        ...state,
        teamData: action.payload,
      };
    case GET_TEAM:
      return {
        ...state,
        teamData: action.payload,
      };
    case UPDATE_TEAM:
      return {
        ...state,
        teamData: state.teamData.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item,
        ),
      };
    case DELETE_TEAM:
      return {
        ...state,
        teamData: state.teamData.filter((item) => item.id !== action.payload),
      };
    default:
      return state;
  }
};
